import {
  ACTION_LOGIN__REQUEST,
  ACTION_LOGIN__SUCCESS,
  ACTION_LOGIN__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOGIN__REQUEST:
    case ACTION_LOGIN__SUCCESS:
      return null;

    case ACTION_LOGIN__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
